module.exports = __webpack_public_path__ + "img/programme3.6144a859.png";